import { useNavigate, useSearchParams } from 'react-router-dom';
import { MyPantry } from '../components/Pantry/MyPantry';
import { usePageTitle } from '../hooks/usePageTitle';

export const PantryPage = () => {
  usePageTitle('My Pantry | Meals You Love');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBack = () => {
    navigate(-1);
  };

  const initialSearch = searchParams.get('search') || '';

  return <MyPantry onBack={handleBack} initialSearch={initialSearch} />;
};